<template>
  <div class="video_outer">
    <video
        id="video-live"
        class="video-js vjs-big-play-centered video-custom-class"
        webkit-playsinline
        playsinline
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="landscape"></video>
    <Modal
      v-model="modal"
      title="输入手机号码"
      :mask-closable="false"
      footer-hide>
        <Form ref="form" :model="formModal" :rules="rules" inline>
        <FormItem prop="phone">
            <i-input type="text" v-model="formModal.phone" placeholder="手机号">
                <Icon type="ios-call-outline" slot="prepend"/>
            </i-input>
        </FormItem>
        <i-button @click="ok" type="primary">确定</i-button>
        </Form>
    </Modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import playerConfig from '@/constant/nimConfig'
export default {
  data () {
    return {
      urls: null,
      modal: true,
      formModal: {
        phone: '',
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' },
        ],
      },
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions({
      getChannelAddressTranscode: 'live/getChannelAddressTranscode',
      saveFiscalPhone: 'course/saveFiscalPhone',
    }),
    init () {
      // 获取直播转码地址
      let channel = this.$route.params.cid
      this.getChannelAddressTranscode({ channel: channel })
        .then((res) => {
          this.urls = res
        })
    },
    ok () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 调用法税接口记录后调用获取地址的方法初始化播放器
          this.saveFiscalPhone({ phone: this.formModal.phone })
          this.initPlayer()
          this.modal = false
        }
      })
    },
    initPlayer () {
      let conf = Object.assign(playerConfig.initConfig, {
        poster: '/img/tmp/1.jpeg',
        controlBar: { // controlBar: Container of main controls.
          playToggle: true, // playToggle: Button to toggle between play and pause. 播放暂停按钮
          volumeMenuButton: false, // volumeMenuButton: A Component to contain the MuteToggle and VolumeControl so that they can work together.
          currentTimeDisplay: false, // currentTimeDisplay: Displays the current time. (hidden by default)
          timeDivider: false, // timeDivider: The separator between the current time and duration. Can be hidden if it's not needed in the design. (hidden by default)
          durationDisplay: false, // durationDisplay: Displays the duration. (hidden by default)
          progressControl: false,
          liveDisplay: false, // liveDisplay: Displays the live indicator when duration is Infinity. (hidden during VOD playback)
          remainingTimeDisplay: false,
          fullscreenToggle: true,
        },
      })
      this.player = window.neplayer('video-live', conf, () => {
        this.player.setDataSource([
          { src: this.urls.httpPullUrl, type: 'video/x-flv' },
          { src: this.urls.hlsPullUrl, type: 'application/x-mpegURL' },
        ])
        this.player.play()
      })
    },
    validatePhone (rule, value, callback) {
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    },
  },
}
</script>
<style lang="scss">
.video_outer {
  position: fixed;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;
  .vjs-tech {
    z-index: 1;
  }
  .vjs-control-bar {
    z-index: 1;
  }
}
</style>
